var Class = require('Class'),
    $     = require("jquery"),
    ol    = require("openlayers");

var OmsExtTileCounter = Class.extend({
    initialize: function(view){
        var that = this;
        that.view = view;
        that.lastTilesCount = 0;

        setInterval(function(){
            var tc = that.countTiles();
            if(that.lastTilesCount == tc) return void(0);
            that.lastTilesCount = tc;
            window.postMessage({
                tilesCount: that.lastTilesCount
            }, '*');
        }, 500);
    },

    countTiles: function(){
        var that = this;
        var canvas = $(that.view._elements.mapContainer).find('canvas');
        var tileSize = 256; // TODO: ����� ���������� �����������. � ���� ����� ���� ������ ������ ������.
        var layers = that.view._map
            .getLayers()
            .getArray();

        var layersCount = that._getTileLayers(layers).length;

        var tX = Math.ceil(canvas.width() / tileSize);
        var tY = Math.ceil(canvas.height() / tileSize);
        var tilesPerLayer = tX * tY;
        return tilesPerLayer * layersCount
    },

    _getTileLayers: function(layers){
        var tileLayers = [];
        var layersLength = layers.length;
        var that = this;
        for(var i = 0; i < layersLength; i++){
            // ���� ���� ��������� - ��� ������, �� ��� �� ����������.
            if(!layers[i].getVisible()){
                continue;
            }
            // ���� ��� ������ ���� - ������ � ��������
            if(layers[i] instanceof ol.layer.Group){
                tileLayers.push.apply(tileLayers, that._getTileLayers(layers[i].getLayers().getArray()));
            }else if(layers[i] instanceof ol.layer.Tile){
                tileLayers.push(layers[i]);
            }
        }
        return tileLayers;
    }
});

module.exports = OmsExtTileCounter;


//////////////////
// WEBPACK FOOTER
// ./src/View/OmsExtTileCounter.js
// module id = 237
// module chunks = 0